import Vue from 'vue';
import Vuetify from 'vuetify';
import 'vuetify/dist/vuetify.min.css';
// import 'vuetify/dist/vuetify.min.css';
import App from './App.vue';
import router from './router';
import store from './store';
import './registerServiceWorker';
// import 'vuetify/dist/vuetify.min.css';
import mixins from './mixins';
import localStorage from './utils/localStorage';
import repo from './repositories/repo'
import produce from 'immer'
import _ from 'lodash'

window.produce = produce
window._ = _

Vue.prototype.$repo = repo

Vue.use(Vuetify, {
    iconfont: 'md'
});

window.moment = require('moment');
window.toastr = require('vuetify-toast');

Vue.config.productionTip = false;

Vue.mixin(mixins);

import * as dt from './utils/datetime';
Object.defineProperties(Vue.prototype, {
    $dt: {
        get: () => dt
    }
})

// Global components
import Title from './components/widgets/Title';
import SubTitle from './components/widgets/SubTitle';
import ItemLabel from './components/widgets/ItemLabel';
Vue.component('app-title', Title);
Vue.component('app-sub-title', SubTitle);
Vue.component('app-item-label', ItemLabel);

// Filtros
Vue.filter('datetime', (val) => {
    if (!val) return '';

    let date = moment(val);

    return date.isValid() ? date.format("DD/MM/YYYY HH:mm:ss") : '';
});
Vue.filter('date', (val) => {
    if (!val) return '';

    let date = moment(val);

    return date.isValid() ? date.format("DD/MM/YYYY") : '';
});
Vue.filter('duration', (val) => {
    if (!val) return '';

    let date = moment(val);

    return date.isValid() ? date.fromNow() : '';
});
Vue.filter('yesno', (val) => {
    return !!val ? 'Si' : 'No';
});

new Vue({
    router,
    store,
    // vuetify: new Vuetify(opts),
    render: h => h(App)
}).$mount('#app');
